import { combineReducers, configureStore } from "@reduxjs/toolkit";
import hardSet from "redux-persist/es/stateReconciler/hardSet";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/es/storage/session";
import authReducer from "../slice/auth/authSlice";
import officeReducer from "../slice/office/officeSlice";
import staffReducer from "../slice/staff/staffSlice";
import userReducer from "../slice/user/userSlice";
import customerReducer from "../slice/customer/customerSlice";
import accountingReducer from "./../slice/accounting/accountingSlice";
import roleReducer from "../slice/roles/roleSlice";
import permissionReducer from "../slice/permission/permissionSlice";
import policyReducer from "../slice/policy/policySlice";
import clauseReducer from "../slice/clauses/clauseSlice";
import commissionReducer from "../slice/commission/commissionSlice";
import dashReducer from "../slice/dash/dashSlice";
import underwritingReducer from "../slice/underwriting/underwritingSlice";
import reportReducer from "../slice/report/reportSlice";
import transactionReducer from "../slice/transaction/transactionSlice";
import coverReducer from "../slice/cover/coverSlice";
import workflowReducer from "../slice/workflow/workflowSlice";
import claimReducer from "../slice/claim/claimSlice";
import savingsClaimReducer from "../slice/claim/savingClaimSlice";
import formReducer from "../slice/form/formSlice";
import chargesReducer from "../slice/charges/chargesSlice";
import lifecoverReducer from "../slice/lifecover/lifecoverSlice";
import pendingActionsReducer from "../slice/pendingActions/pendingActionsSlice";
import migrationReducer from "./../slice/migration/migrationSlice";
import savingsPolicyReducer from "../slice/policy/savingsPolicy/savingsPolicySlice";
import coinsuranceReducer from "../slice/coinsurance/coinsuraceSlice";

const persistConfig = {
  key: "root",
  version: 1,
  // storage,
  storage: sessionStorage,
  stateReconciler: hardSet,
};

const reducer = combineReducers({
  auth: authReducer,
  office: officeReducer,
  staff: staffReducer,
  user: userReducer,
  customer: customerReducer,
  accounting: accountingReducer,
  role: roleReducer,
  permission: permissionReducer,
  policy: policyReducer,
  clause: clauseReducer,
  commission: commissionReducer,
  dash: dashReducer,
  underwriting: underwritingReducer,
  report: reportReducer,
  transaction: transactionReducer,
  cover: coverReducer,
  workflow: workflowReducer,
  claim: claimReducer,
  form: formReducer,
  charges: chargesReducer,
  pendingActions: pendingActionsReducer,
  migration: migrationReducer,
  savingsPolicy: savingsPolicyReducer,
  lifecover: lifecoverReducer,
  savingsClaim: savingsClaimReducer,
  coinsurance: coinsuranceReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  // reducer: {
  //     auth: authReducer,
  //     office: officeReducer,
  // },
  // devTools: false
});

export default store;
